/** Currencies supported by company and employee financial forms. */
export const SUPPORTED_CURRENCIES = ['EGP', 'SAR', 'AED', 'USD', 'JOD'] as const
